// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsBoard-moduleRentalPortalListingsBoard__e9pcT";
var _2 = "RentalPortalListingsBoard-modulecolumns__MdnCH";
export { _1 as "RentalPortalListingsBoard", _2 as "columns" }
